// Razorpay Custom Checkout (razorpay.js) — direct UPI app opening (UPI Intent).
// checkout.js and razorpay.js both claim `window.Razorpay`, so the custom
// constructor is parked on `window.RazorpayCustom` and the standard one restored.
const CUSTOM_SRC = "https://checkout.razorpay.com/v1/razorpay.js";
let customPromise = null;

export function loadCustomRazorpay() {
  if (window.RazorpayCustom) return Promise.resolve(window.RazorpayCustom);
  if (customPromise) return customPromise;
  customPromise = new Promise((resolve) => {
    const standard = window.Razorpay;
    const s = document.createElement("script");
    s.src = CUSTOM_SRC;
    s.async = true;
    s.onload = () => {
      window.RazorpayCustom = window.Razorpay;
      if (standard) window.Razorpay = standard;
      else delete window.Razorpay;
      resolve(window.RazorpayCustom || null);
    };
    s.onerror = () => { customPromise = null; resolve(null); };
    document.body.appendChild(s);
  });
  return customPromise;
}

// "android-webview" (our Android app), "mweb" (phone browser), or null
// (desktop / iOS app — keep Standard Checkout there for now).
export function upiIntentMode() {
  const cap = typeof window !== "undefined" ? window.Capacitor : null;
  if (cap?.isNativePlatform?.()) return cap.getPlatform?.() === "android" ? "android-webview" : null;
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  return /Android|iPhone|iPad|iPod/i.test(ua) ? "mweb" : null;
}

const APP_CODES = { phonepe: "phonepe", gpay: "gpay", paytm: "paytm", other_upi: "any" };

export function intentAppFor(method, mode) {
  if (!mode) return null;
  const code = APP_CODES[method] || null;
  const isAndroid = mode === "android-webview" || /Android/i.test(navigator.userAgent);
  if (code === "any" && !isAndroid) return null; // "any" is Android-only per Razorpay
  return code;
}

export function isRealPhone(contact) {
  return String(contact || "").replace(/\D/g, "").length >= 10;
}

export function startUpiIntent(Ctor, { order, app, contact, email, webview, onSuccess, onError }) {
  const rzp = new Ctor({ key: order.key_id, webview_intent: webview });
  rzp.on("payment.success", onSuccess);
  rzp.on("payment.error", onError);
  rzp.createPayment(
    {
      amount: order.amount_paise,
      currency: "INR",
      order_id: order.order_id,
      method: "upi",
      contact,
      email,
      description: "Wallet Top-up",
    },
    { app },
  );
  return rzp;
}
